import styled from 'styled-components';
import { w as withTaktFallbackId } from '../../TaktIdContext/TaktIdContext-DlOuPWuU.js';
import { D as DEVICE_TYPES } from '../../LocalModules/storm-ui-utils/dist/esm/deviceTypes-wW4MAd2m-wW4MAd2m.js';
import { I as Icon } from '../../Icon/Icon-BzSaWXwl.js';
import { T as TextButton } from '../../Button/TextButton/TextButton-Cbx2XMWv.js';

/**
 * Take the name of a size and get its value from the theme
 */
const getPadding = (theme, size = 'xlarge', deviceType = DEVICE_TYPES.DESKTOP) => {
  if (deviceType === DEVICE_TYPES.MOBILE) {
    if (theme && theme.mobile && theme.mobile.spacingValues && typeof theme.mobile.spacingValues[size] !== 'undefined') {
      return theme.mobile.spacingValues[size];
    }
  }
  if (theme && theme.spacingValues && typeof theme.spacingValues[size] !== 'undefined') {
    return theme.spacingValues[size];
  }
  return theme.spacingValues.base;
};
const PopperContent = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30074035__sc-1jjcmjm-0"
})(["padding:", "px;overflow:visible;"], ({
  $padding,
  theme
}) => getPadding(theme, $padding));
PopperContent.displayName = 'PopperContent';
const PopperContentWithTopCornerIcon = /*#__PURE__*/styled(PopperContent).withConfig({
  componentId: "sc-storm-ui-30074035__sc-1jjcmjm-1"
})(["padding:", " ", ";"], ({
  theme
}) => theme.tooltip.paddingTopBottomWithTopCornerIcon, ({
  theme
}) => theme.tooltip.paddingLeftRightWithTopCornerIcon);
PopperContentWithTopCornerIcon.displayName = 'PopperContentWithTopCornerIcon';
const TooltipScrollContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30074035__sc-1jjcmjm-2"
})(["overflow-x:auto;"]);
TooltipScrollContainer.displayName = 'TooltipScrollContainer';
const TooltipMessage = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30074035__sc-1jjcmjm-3"
})(["", ";"], ({
  theme
}) => theme.typography.base);
TooltipMessage.displayName = 'TooltipMessage';
const CloseButtonBase = /*#__PURE__*/styled(TextButton).withConfig({
  componentId: "sc-storm-ui-30074035__sc-1jjcmjm-4"
})(["opacity:", ";padding:", ";text-align:center;color:", ";outline:none;margin-inline-start:", ";:hover{opacity:1;background:", ";color:", ";}@media (prefers-reduced-motion:no-preference){transition:background .2s ease-in-out;}:focus{opacity:1;}"], ({
  $styleType
}) => $styleType === 'blue' || $styleType === 'dark' ? 1 : 0.5, ({
  theme
}) => theme.tooltip.closeIcon.padding, ({
  $styleType,
  theme
}) => theme.tooltip.closeIcon[$styleType], ({
  theme
}) => theme.tooltip.closeIcon.marginLeft, ({
  $styleType,
  theme
}) => theme.tooltip.closeIconBg[$styleType], ({
  $styleType,
  theme
}) => theme.tooltip.closeIcon[$styleType]);
const CloseButton = withTaktFallbackId(CloseButtonBase);
const CloseIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-30074035__sc-1jjcmjm-5"
})(["line-height:1;margin:0;padding:0;display:inline-block;.svg-inline--fa{vertical-align:", ";width:", ";}"], ({
  theme
}) => theme.tooltip.closeIcon.svg.verticalAlign, ({
  theme
}) => theme.tooltip.closeIcon.svg.width);
CloseIcon.displayName = 'CloseIcon';
const FlexContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30074035__sc-1jjcmjm-6"
})(["display:flex;align-items:flex-start;"]);
const ContentContainerWithTopCornerIcon = /*#__PURE__*/styled(FlexContainer).withConfig({
  componentId: "sc-storm-ui-30074035__sc-1jjcmjm-7"
})(["padding:", " ", ";"], ({
  theme
}) => theme.tooltip.contentPaddingTopBottomWithTopCornerIcon, ({
  theme
}) => theme.tooltip.contentPaddingLeftRightWithTopCornerIcon);
ContentContainerWithTopCornerIcon.displayName = 'ContentContainerWithTopCornerIcon';
const ChildrenWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30074035__sc-1jjcmjm-8"
})(["width:100%;"]);

export { ChildrenWrapper as C, FlexContainer as F, PopperContent as P, TooltipScrollContainer as T, CloseButton as a, CloseIcon as b };
//# sourceMappingURL=PopperContentContainer.styles-zqmfTzCS.js.map
